import { render, staticRenderFns } from "./resultHonor.vue?vue&type=template&id=0ac1fc45&scoped=true&"
import script from "./resultHonor.vue?vue&type=script&lang=js&"
export * from "./resultHonor.vue?vue&type=script&lang=js&"
import style0 from "./resultHonor.vue?vue&type=style&index=0&id=0ac1fc45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac1fc45",
  null
  
)

export default component.exports